/**
 * Notification display message constants.
 * Shared across tool-specific transformers.
 */

// Planogram / Fixture Task
export const PLANOGRAM_TOOL_NAME = 'Planogram'
export const PLANOGRAM_TOOL_URL = '/tools/planogram'
export const PLANOGRAM_DEEP_URL_PREFIX = '/validate-fixture?fixtureId='
export const PLANOGRAM_AGGREGATED_MESSAGE = 'Misplaced items'
export const PLANOGRAM_INDIVIDUAL_MESSAGE_SINGULAR = 'Misplaced item'
export const planogramIndividualMessage = (count: number): string =>
    count === 1 ? PLANOGRAM_INDIVIDUAL_MESSAGE_SINGULAR : `${count} misplaced items`
export const planogramAggregatedDetail = (fixtures: number, items: number): string =>
    `${fixtures} fixtures ${items} items total`

// Actions
export const ACTION_SOLVE = 'Solve'
export const ACTION_VIEW_DETAILS = 'View details'
